import { useParams } from 'react-router-dom';
import CaseSummaryWrapper from '../../../components/CaseSummaryWrapper';

const CaseDetailPage = () => {
    const { caseId } = useParams();
    return <CaseSummaryWrapper caseId={caseId} />;
};

export default CaseDetailPage;
